import { render, staticRenderFns } from "./PackDataList.vue?vue&type=template&id=328b2f78"
import script from "./PackDataList.vue?vue&type=script&lang=js"
export * from "./PackDataList.vue?vue&type=script&lang=js"
import style0 from "./PackDataList.vue?vue&type=style&index=0&id=328b2f78&prod&lang=css"
import style1 from "./PackDataList.vue?vue&type=style&index=1&id=328b2f78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports